<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  // destroyed(){
  // 	sessionStorage.clear();
  // }
}
</script>

<style>
#app {
  width: 100%;
  font-family: 'PingFangSC-Regular', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height:100%;
}
</style>



// WEBPACK FOOTER //
// App.vue?302a592c